import React from 'react';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/Select';
import { Label } from '@/components/ui/Label';
import { Search, X } from 'lucide-react';
interface PendingUsersFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  statusFilter: string;
  onStatusFilterChange: (status: string) => void;
  selectedCustomerId: number | null | undefined;
  onCustomerFilterChange: (customerId: number | null | undefined) => void;
  customers: Array<{ id: number; customer_name: string; customer_code?: string }>; // 필터에 필요한 최소 필드만
  showCustomerFilter: boolean;
  loading: boolean;
  onReset: () => void;
}

export const PendingUsersFilters: React.FC<PendingUsersFiltersProps> = ({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  selectedCustomerId,
  onCustomerFilterChange,
  customers,
  showCustomerFilter,
  loading,
  onReset,
}) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end">
        {showCustomerFilter && (
          <div className="md:col-span-2 lg:col-span-2">
            <Label>고객사 필터</Label>
            <Select
              value={selectedCustomerId === null ? 'none' : (selectedCustomerId === undefined ? 'all' : selectedCustomerId.toString())}
              onValueChange={(value) => {
                if (value === 'none') {
                  onCustomerFilterChange(null); // "(미입력)"
                } else if (value === 'all') {
                  onCustomerFilterChange(undefined); // "전체 고객사" (필터링 안 함)
                } else {
                  onCustomerFilterChange(parseInt(value, 10));
                }
              }}
            >
              <SelectTrigger>
                <SelectValue placeholder="고객사 선택" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem key="customer-none" value="none">(미입력)</SelectItem>
                <SelectItem key="customer-all" value="all" className="font-bold">전체 고객사</SelectItem>
                {customers.map((customer) => (
                  <SelectItem key={`customer-${customer.id}`} value={customer.id.toString()}>
                    {customer.customer_name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
        {/* 상태 - 작은 크기 */}
        <div className="md:col-span-2 lg:col-span-2">
          <Label>상태</Label>
          <Select value={statusFilter} onValueChange={onStatusFilterChange}>
            <SelectTrigger className="h-10">
              <SelectValue placeholder="전체" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem key="status-all" value="all">전체</SelectItem>
              <SelectItem key="status-pending" value="pending">승인 대기</SelectItem>
              <SelectItem key="status-invited" value="invited">초대됨</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {/* 이메일 검색 - 반응형 너비 조정 (총 12칸 맞춤) */}
        <div className={showCustomerFilter ? 'md:col-span-5 lg:col-span-6' : 'md:col-span-6 lg:col-span-8'}>
          <Label>이메일 검색</Label>
          <Input
            type="text"
            placeholder="이메일로 검색..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                // 클라이언트 사이드 필터링이므로 즉시 반영됨
              }
            }}
            className="w-full min-w-0"
          />
        </div>
        {/* 버튼들 - 오른쪽 정렬 (총 12칸 맞춤) */}
        <div className={`${showCustomerFilter ? 'md:col-span-3 lg:col-span-2' : 'md:col-span-4 lg:col-span-2'} flex items-end gap-2 flex-shrink-0`}>
          <Button
            variant="outline"
            onClick={onReset}
            disabled={loading}
            className="h-10"
          >
            <X className="mr-2 h-4 w-4" />
            초기화
          </Button>
          <Button
            onClick={() => {
              // 클라이언트 사이드 필터링이므로 즉시 반영됨
            }}
            disabled={loading}
            className="h-10"
          >
            <Search className="mr-2 h-4 w-4" />
            검색
          </Button>
        </div>
      </div>
    </div>
  );
};

